module.exports = __webpack_public_path__ + "img/02_en.39d971bc.png";